import angular from 'angular';
import moment from 'moment';

export const parseNumberFormat = format => {
  const elements = [];
  if (!format) return elements;

  let part = '';
  let inBlock = false;
  for (let i = 0; i < format.length; i++) {
    //TFS 5732
    const c = format[i];

    if (!inBlock && c === '[') {
      inBlock = true;

      if (part !== '') {
        elements.push({ id: 'Text', t: part });
        part = '';
      }
    } else if (inBlock && c === ']') {
      inBlock = false;
      part = part.toLowerCase();

      switch (part) {
        case 'yyyy':
          elements.push({ id: 'Yyyy', n: 0 });
          break;
        case 'yy':
          elements.push({ id: 'Yy', n: 0 });
          break;
        case 'mm':
          elements.push({ id: 'Mm', n: 0 });
          break;
        default:
          var n = parseInt(part.replace('counter:n', '').trim());
          if (Number.isInteger(n)) {
            elements.push({ id: 'Counter', n: n });
          }
          break;
      }

      part = '';
    } else {
      part += c;
    }
  }
  if (part !== '') {
    elements.push({ id: 'Text', t: part });
    part = '';
  }
  return elements;
};
const generateDateParts = date => ({
  Yyyy: date.getFullYear(),
  Yy: ('' + date.getFullYear()).substr(-2),
  Mm: ('' + (date.getMonth() + 1)).padStart(2, '0'),
});

const randomCounter = Math.round(Math.random() * 500);
export const generateExample = (input, date, yearFormat, counter) => {
  if (!input) return null;
  let elements = [];
  //Format as string
  if (typeof input === 'string') elements = parseNumberFormat(input);
  //Format as array of elements
  else if (typeof input === 'object' && input.length) elements = input;
  else return null;

  const exampleDate = date ? moment.utc(date).toDate() : moment.utc().toDate();
  if (date && yearFormat === 3) {
    exampleDate.setFullYear(exampleDate.getFullYear() + 1);
  }
  const exampleCounter = parseInt(counter) || randomCounter;
  const examples = { ...generateDateParts(exampleDate), Counter: exampleCounter };

  return elements.reduce(function(result, el) {
    if (el.id === 'Text') return result + el.t;
    if (el.id === 'Counter') return result + ('' + examples[el.id]).padStart(el.n, '0');
    if (el.id !== 'Text' && el.id !== 'Counter') return result + examples[el.id];
    return result;
  }, '');
};

angular.module('cloudX').directive('cxNumberFormat', [
  function() {
    return {
      restrict: 'E',
      template: require('./numberFormat.html'),
      scope: {
        data: '=',
        submit: '&',
        cancel: '&',
        startDate: '=',
        firstNumber: '=',
        showWarning: '=',
        yearFormat: '=',
      },
      controller: [
        '$scope',
        '$q',
        function($scope, $q) {
          $scope.editMode = false;
          $scope.elements = [];
          $scope.saving = false;

          $scope.parts = [
            { id: 'Yy', n: 0 },
            { id: 'Yyyy', n: 0 },
            { id: 'Mm', n: 0 },
            { id: 'Counter', n: 0 },
            { id: 'Text', t: '' },
          ];
          $scope.addPart = function(nr) {
            if (nr !== 3 || !$scope.hasCounter())
              $scope.elements.push(angular.copy($scope.parts[nr]));
          };

          $scope.numberOfZeros = function(n) {
            var zerostring = '';
            for (var t = 0; t < n; t++) zerostring += '0';
            return zerostring;
          };

          $scope.startEdit = function() {
            $scope.editMode = true;
            $scope.elements = parseNumberFormat($scope.data);
          };
          $scope.dragIndex = null;
          $scope.startDrag = function(e, ui, index) {
            $scope.dragIndex = index;
          };
          $scope.stopDrag = function() {
            $scope.dragIndex = null;
          };
          $scope.dragOver = function(e, ui, index) {
            var dropEl = $(e.target);
            dropEl.removeClass('drop-left').removeClass('drop-right');
            if ($scope.dragIndex == null) return;
            if ($scope.dragIndex < index) dropEl.addClass('drop-right');
            if ($scope.dragIndex > index) dropEl.addClass('drop-left');
          };
          $scope.hasCounter = function() {
            return (
              $scope.elements.findIndex(function(el) {
                return el.id === 'Counter';
              }) >= 0
            );
          };

          $scope.example = function() {
            if (!$scope.editMode)
              return generateExample($scope.data, $scope.startDate, $scope.yearFormat);
            return generateExample($scope.elements, $scope.startDate, $scope.yearFormat);
          };
          $scope.firstNumberExample = function() {
            if (!$scope.editMode)
              return generateExample(
                $scope.data,
                $scope.startDate,
                $scope.yearFormat,
                $scope.firstNumber,
              );
            return generateExample(
              $scope.elements,
              $scope.startDate,
              $scope.yearFormat,
              $scope.firstNumber,
            );
          };

          $scope.cancelEdit = function() {
            $scope.editMode = false;
            $scope.cancel();
          };
          $scope.clear = function() {
            $scope.elements = [];
          };
          $scope.save = function() {
            var result = $scope.elements.reduce(function(result, el) {
              if (el.id === 'Text') return result + el.t;
              if (el.id === 'Counter') return result + ('[Counter:N' + (el.n || '0') + ']');
              if (el.id !== 'Text' && el.id !== 'Counter') return result + ('[' + el.id + ']');
              return result;
            }, '');

            $scope.saving = true;
            return $q.when($scope.submit({ newVal: result })).then(
              function(success) {
                $scope.saving = false;
                //Error. Local model will not be updated, form will not close
                if (typeof success === 'string') return;

                //Success. Local model will be updated automatically
                if (typeof success === 'undefined' || !!success) $scope.data = result;

                //Form will close
                $scope.editMode = false;
              },
              error => {
                $scope.saving = false;
              },
            );
          };
        },
      ],
    };
  },
]);
